
export const storageGet = (key: string): string|null  => {
    try {
        const val = localStorage.getItem(key);
        return val;
    }
    catch (e)
    {
        return null;
    }
}

export const storageSet = (key: string, value: string|null|undefined) => {

    if (value === undefined || value === null) {
        try {
            localStorage.removeItem(key);
        }
        catch (e) {
        }
    } else {
        try {
            localStorage.setItem(key, value);
        }
        catch (e)
        {

        }
    }
}